const { lazy } = require('react');

export const SettingsPageAsync = lazy(() => import('./SettingsPage'))

